import { render } from "./TodayMenuSection.vue?vue&type=template&id=643bb514&scoped=true&ts=true"
import script from "./TodayMenuSection.vue?vue&type=script&lang=ts"
export * from "./TodayMenuSection.vue?vue&type=script&lang=ts"

import "./TodayMenuSection.vue?vue&type=style&index=0&id=643bb514&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-643bb514"]])

export default __exports__